<template>
  <AppModal
    size="5xl"
    :title="`${framework?.name} Goals (${framework?.shortName})`"
    @close="$emit('close')"
  >
    <!-- Modal Body -->
    <template #body>
      <div
        class="mb-4"
        v-html="domPurify.sanitize(framework?.writeUp) || 'No description provided'"
      />

      <span class="block mb-5">The {{ framework.goals?.length }} {{ framework?.name }} Goals are:</span>

      <FrameworkCategoryAccordion :categories="framework.categories" />
    </template>
  </AppModal>
</template>

<script setup>
import { FrameworkCategoryAccordion } from '@/components/framework';
import { AppModal } from '@/components/modals/index.js';
import { useDomPurify } from '@/composables';

const domPurify = useDomPurify();

defineEmits(['close']);

defineProps({
  framework: {
    type: Object,
    default: null,
  },
});
</script>
